module.exports = __webpack_public_path__ + "img/faction.11881532.png";